'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Carousel = require('./Carousel');

Object.defineProperty(exports, 'Carousel', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Carousel).default;
  }
});

var _CarouselItem = require('./CarouselItem');

Object.defineProperty(exports, 'CarouselItem', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CarouselItem).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/carousel/index.js
// module id = 554
// module chunks = 0